<div class="tg-cnt">
    <span *ngIf="labelText != ''" class="tg-label" [ngClass]="{'tg-span-error' : !isValid}">{{labelText}} <span *ngIf="isRequired">*</span></span>
    <div *ngIf="labelText == '' && spaceLabel" style="height: 1.7vh; width:100%"></div>
    <div class="tg-ext">
        <div class="tg-toggle" [ngClass]="{'tg-toggle-on' : isOn, 'tg-toggle-off' : !isOn}" (click)="onToggleClick()">
            <div class="tg-toggle-dot" [ngClass]="{'tg-toggle-dot-on' : isOn, 'tg-toggle-dot-off' : !isOn}"></div>
        </div>
    </div>
</div>
